module.exports = __webpack_public_path__ + "Graphik-Regular.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/fonts/Graphik-Regular.woff
 ** module id = 195
 ** module chunks = 1
 **/